import { AlertCircle, CheckCircle, Loader2 } from 'lucide-react';
import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { NonAuthSidebar } from '@/components/layouts/Sidebar/NonAuthSidebar';
import { Button } from '@/components/ui/button';
import { useVerifyEmail } from '@/hooks/useAuth';

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const sig = searchParams.get('sig') || '';
  const mutation = useVerifyEmail();

  useEffect(() => {
    if (sig && !mutation.isSuccess && !mutation.isError && !mutation.isPending) {
      mutation.mutate({ sig });
    }
  }, [sig]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!sig) {
    return (
      <div className="flex h-screen overflow-hidden">
        <NonAuthSidebar />
        <div className="flex flex-1 items-center justify-center px-4">
          <div className="w-full max-w-md space-y-6 text-center">
            <AlertCircle className="mx-auto h-12 w-12 text-destructive" />
            <h2 className="text-2xl font-semibold">Invalid Link</h2>
            <p className="text-muted-foreground">
              This verification link is invalid or has expired.
            </p>
            <Link to="/login">
              <Button variant="outline" className="mt-4">
                Go to Login
              </Button>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <NonAuthSidebar />
      <div className="flex flex-1 items-center justify-center px-4">
        <div className="w-full max-w-md space-y-6 text-center">
          {mutation.isPending && (
            <>
              <Loader2 className="mx-auto h-12 w-12 animate-spin text-primary" />
              <h2 className="text-2xl font-semibold">Verifying your email...</h2>
              <p className="text-muted-foreground">Please wait a moment.</p>
            </>
          )}

          {mutation.isSuccess && (
            <>
              <CheckCircle className="mx-auto h-12 w-12 text-green-500" />
              <h2 className="text-2xl font-semibold">Email Verified</h2>
              <p className="text-muted-foreground">Your email has been verified successfully.</p>
              <Link to="/login">
                <Button className="mt-4">Go to Login</Button>
              </Link>
            </>
          )}

          {mutation.isError && (
            <>
              <AlertCircle className="mx-auto h-12 w-12 text-destructive" />
              <h2 className="text-2xl font-semibold">Verification Failed</h2>
              <p className="text-muted-foreground">
                {(mutation.error as { response?: { data?: { error?: string } } })?.response?.data
                  ?.error || 'This verification link is invalid or has expired.'}
              </p>
              <Link to="/login">
                <Button variant="outline" className="mt-4">
                  Go to Login
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
